import React from "react";
import styled from "styled-components";

interface Props {
  width?: number;
}

export const ImgOuter = styled.img`
  width: ${(props: Props) => `${props.width}`}px;
`;
